import dynamic from "next/dynamic";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";

export const CoreRichEditor = dynamic(
  () => import("./core-editor/core-editor-component"),
  {
    ssr: false,
  }
);

const RichText = dynamic(
  () => import("./stateful-editor/stateful-editor-component"),
  {
    ssr: false,
  }
);

// @ts-ignore
RichText.craft = {
  custom: {
    displayName: "Rich text",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};

export default RichText;
